import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ContractDto } from '../../beneficiaries/beneficiary-folder/contract/contract.dto';
import { DisplayContract } from '../../beneficiaries/beneficiary-folder/contract/displayContract';
import { environment } from '../../environments/environment';
import { Pagination } from '../pagination/pagination';
import { PaginationOptions } from '../pagination/pagination-options';
import { TraceabilityDto } from '../traceability/traceability.dto';
import { ApiService, FileResponse } from './api.service';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class ContractsService {
  public contractUpdate: Subject<ContractDto> = new Subject<ContractDto>();
  public contractUpdated$: Observable<ContractDto> = this.contractUpdate.asObservable();
  constructor(private readonly api: ApiService, private readonly fileService: FileService) {}

  public async findByBeneficiaryId(id: number, options: PaginationOptions): Promise<Pagination<DisplayContract>> {
    const uri: string = environment.api.contracts + '/' + id;
    return this.api.getPaginated<DisplayContract>(options.buildUrl(uri));
  }

  public async downloadDocument(contractId: number): Promise<void> {
    const uri: string = environment.api.contracts + '/' + contractId + '/document';
    const { filename, data }: FileResponse = await this.api.getFileWithName(uri);
    return this.fileService.saveAs(data, filename);
  }

  public async findByContractId(contractId: number, contractType: string): Promise<ContractDto> {
    const result = await this.api.get<ContractDto>(environment.api.contracts + '/' + contractId + '/details?contractType=' + contractType);
    const dto: ContractDto = ContractDto.fromJson(result);
    return dto;
  }

  public async saveContract(contract: ContractDto): Promise<void> {
    await this.api.post(environment.api.contracts, contract);
    this.contractUpdate.next(contract);
  }

  public async delete(id: number, contractType: string): Promise<void> {
    await this.api.delete(environment.api.contracts + '/' + id + '?contractType=' + contractType);
    this.contractUpdate.next(undefined);
  }

  public async updateStatus(traceabilityDto: TraceabilityDto, contractType: string): Promise<void> {
    this.contractUpdate.next(undefined);
    await this.api.post(environment.api.contracts + '/status/' + contractType, traceabilityDto);
  }

  public async getDatesContract(beneficiaryId: number): Promise<any> {
    const result = await this.api.get<ContractDto>(environment.api.contracts + '/' + beneficiaryId + '/get-new-contracts-dates');
    return result;
  }
}
